import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Carousel from "react-bootstrap/Carousel";
import "../style/Services.css";

const API_KEY = "52d02af9e692eaf76fadee8a3119e0d2"; // My TMDb API key

function Services() {
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    // Fetch movie data from the TMDb API
    axios
      .get(`https://api.themoviedb.org/3/movie/popular?api_key=${API_KEY}`)
      .then((response) => setMovies(response.data.results))
      .catch((error) => console.error(error));
  }, []);

  const handleWatchNow = () => {
    window.open(`https://www.themoviedb.org/movie/`, "_blank");
  };

  //Here is my code of fetching API's data for movie trailers

  const [movieTrailers, setMovieTrailers] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await axios.get(
        "https://www.googleapis.com/youtube/v3/search",
        {
          params: {
            part: "snippet",
            maxResults: 8,
            q: "movie trailer",
            type: "video",
            key: "AIzaSyAumd4RLV5IJr8vxQh99vbKVo6VbzKnaC4", //My YouTube API Key
          },
        }
      );
      setMovieTrailers(response.data.items);
    }
    fetchData();
  }, []);

  return (
    <>
      {/*--------------------------Start of Carousel-------------------------- */}
      <div className="container">
        <Carousel>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://lumiere-a.akamaihd.net/v1/images/pp_themenu_herobanner_1073_v2_e10da279.jpeg?region=0,0,2048,878&width=1536"
              alt="First slide"
            />
            <Carousel.Caption>
              <h3>The Menu</h3>
              <p className="caption">
                A young couple travels to a remote island to eat at an exclusive
                restaurant where the chef has prepared a lavish menu, with some
                shocking surprises.
              </p>
              <button className="watch-now" onClick={handleWatchNow}>
                Watch Now
              </button>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://lumiere-a.akamaihd.net/v1/images/b_20centurystudios_amsterdam_herobanner_372_676a5dee.jpeg?region=0,0,2048,878&width=1536"
              alt="Second slide"
            />
            <Carousel.Caption>
              <h3>Amsterdam</h3>
              <p className="caption">
                A young couple travels to a remote island to eat at an exclusive
                restaurant where the chef has prepared a lavish menu, with some
                shocking surprises.
              </p>
              <button className="watch-now" onClick={handleWatchNow}>
                Watch Now
              </button>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://lumiere-a.akamaihd.net/v1/images/hb_20cs_thebansheesofinisherin_v2_981_e9806d97.jpeg?region=0,0,2048,878&width=1536"
              alt="Third slide"
            />
            <Carousel.Caption>
              <h3>The Banshees of Inisherin</h3>
              <p className="caption">
                Two lifelong friends find themselves at an impasse when one
                abruptly ends their relationship, with alarming consequences for
                both of them.
              </p>
              <button className="watch-now" onClick={handleWatchNow}>
                Watch Now
              </button>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://lumiere-a.akamaihd.net/v1/images/hb_20thcentury_empireoflight_1358_5962fd06.jpeg?region=0,0,2048,878&width=1536"
              alt="Third slide"
            />
            <Carousel.Caption>
              <h3>Empire Of Light</h3>
              <p className="caption">
                A drama about the power of human connection during turbulent
                times, set in an English coastal town in the early 1980s.
              </p>
              <button className="watch-now" onClick={handleWatchNow}>
                Watch Now
              </button>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        {/*--------------------------End of Carousel-------------------------- */}

        {/*--------------------------Start of Movie Cards-------------------------- */}
        <h1 className="tittle">Popular Movies</h1>
        <div className="row justify-content-center">
          {movies.map((movie) => (
            <div className="col-sm-3" key={movie.id}>
              <div className="card">
                <img
                  src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                  className="card-img-top"
                  alt={movie.title}
                />
                <div className="card-body">
                  <h5 className="cards-title">{movie.title}</h5>
                  <p className="cards-text">{movie.release_date}</p>
                  <button className="btn-watch-now" onClick={handleWatchNow}>
                    Watch now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/*--------------------------End of Movie Cards-------------------------- */}

      <h1 className="trailers-tittle">Movie Trailers</h1>
      <div className="movie-trailer-list">
        {movieTrailers.map((trailer) => (
          <div key={trailer.id.videoId} className="movie-trailer">
            <div className="video-player">
              <iframe
                src={`https://www.youtube.com/embed/${trailer.id.videoId}`}
                title={trailer.snippet.title}
              ></iframe>
            </div>
            <h3>{trailer.snippet.title}</h3>
            <p className="trailers-description">
              {trailer.snippet.description}
            </p>
          </div>
        ))}
      </div>

      {/*-----------Start of Footer----------- */}
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>&copy; 2023 Roland Ajeti. All Rights Reserved.</p>
            </div>
            <div className="col-md-6">
              <ul className="footer-links">
                <li>
                  <a href="home" className="anchor">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="home" className="anchor">
                    Contact Us
                  </a>
                </li>
              </ul>
              <ul className="social-icons">
                <li>
                  <a
                    href="https://www.instagram.com/rolandajeti/"
                    aria-label="Take a look at my Instagram Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "instagram"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/roland-ajeti-834335207/"
                    aria-label="Take a look at my LinkedIn Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "linkedin"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCA7Tj3B9h2FikEHcEJI4cnQ"
                    aria-label="Take a look at my Youtube Profile"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={["fab", "youtube"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/RolandAjeti"
                    target={"_blank"}
                    rel="noreferrer"
                    aria-label="Take a look at my Twitter Profile"
                  >
                    <FontAwesomeIcon icon={["fab", "twitter"]} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://rolandajeti-portfolio-website.netlify.app/"
                    aria-label="Take a look at my Portfolio Website"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faBriefcase} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/*-----------End of Footer----------- */}
    </>
  );
}
export default Services;
